import { DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';
import Draggable from './Draggable';

export default Draggable;

export type WidgetTypeDataChart =
  | 'TCTP'
  | 'CRP'
  | 'TBR'
  | 'MCC'
  | 'MFC'
  | 'CLEC'
  | 'LE'
  | 'SR'
  | 'KI'
  | 'CRC'
  | 'LOC'
  | 'TSI'
  | 'CTM'
  | 'Budget'
  | 'CPM'
  | 'Rater';

export type WidgetChartType = 'bar' | 'line' | 'pie' | 'doughnut' | 'table';

export type WidgetConfig = {
  widgetDashboardUrlID?: string;
  title: string;
  display: boolean;
  posisi: number;
  chartType: WidgetChartType; // Add other chart types as needed
  typeDataChart: WidgetTypeDataChart; // Add other data chart types as needed
  onDelete?: (item: any) => void;
};

export interface DraggableComponentProps {
  data: any[];
  provided?: DroppableProvided;
  snapshot?: DroppableStateSnapshot;
  onHide: (item: WidgetConfig) => void;
}
